import { RedditAgentDashboard } from '@/components/reddit'

export default function RedditDashboardPage() {
  return <RedditAgentDashboard />
} 